(function (window) {
  var win = window,
    sys = {},
    ua = navigator.userAgent.toLowerCase();
  (/msie\s+(\d+)/.test(ua)) ? sys.ie = RegExp.$1 :
    (/firefox\/(\d+)/.test(ua)) ? sys.firefox = RegExp.$1 :
      (/chrome\/(\d+)/.test(ua)) ? sys.chrome = RegExp.$1 :
        (/opera.(\d+)/.test(ua)) ? sys.opera = RegExp.$1 :
          (/version\/(\d+).*safari/.test(ua)) ? sys.safari = RegExp.$1 : 0;
  var isIE11 = navigator.userAgent.indexOf('Trident') > -1 && navigator.userAgent.indexOf("rv:11.0")
  if ((sys.ie && sys.ie < 10)) {
    // 浏览器版本过低
    var divDOM = document.createElement("div");
    divDOM.id = "alert_browser";
    divDOM.innerHTML = "<p style='z-index:999999;font-family:Georgia,Serif;width:100%;height:50px;line-height:50px;font-size:14px;margin:0;padding:0;" +
      "text-align:center;position:absolute;left:0;top:0;" +
      "background-color:#FAFAD2;border-bottom: 1px solid #DCDCDC'>系统检测您的浏览器版本过低，您可以使用IE 10以及10以上内核的Edge浏览器，请升级您的浏览器&nbsp;&nbsp;" +
      "<a target='_blank' href='http://chrome.360.cn/' style='margin:0 10px;'><img style='vertical-align:middle;border:none;' src='https://p3.ssl.qhimg.com/t0150301cc5cf15e872.png' width='40.48' height='30' title='360急速浏览器' /></a>" +
      "<a target='_blank' href='http://dl.pconline.com.cn/download/51614-1.html' style='margin:0 10px;'><img style='vertical-align:middle;border:none;' src='https://cdn1.iconfinder.com/data/icons/smallicons-logotypes/32/chrome-512.png' width='30' height='30' title='谷歌浏览器' /></a>" +
      "<a target='_blank' href='https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads' style='margin:0 10px;'><img style='vertical-align:middle;border:none;' src='https://vignette1.wikia.nocookie.net/kirby/images/4/40/IE.png/revision/latest?cb=20110716080705&path-prefix=en' width='30' height='30' title='Edge浏览器' /></a>" +
      "<p>";
    document.body.appendChild(divDOM)
  }
})(window)
$(document).ready(function ($) {
    var _winw = $(window).width();
    // 手机导航
    $('body').on('click','.menuBtn', function () {
        $(this).toggleClass('open');
        $('.nav').stop().slideToggle();
    });
    // 下拉搜索
    $('body').on('click','.attr-nav', function () {
        $('.select dd').stop().slideUp('fast');
        $('.top-search').stop().slideToggle();
        return false;
    });
    $('body').on('click','.top-search .close-search', function () {
        $('.top-search').stop().slideUp();
        return false;
    });
    $('body').on('click','.header_search', function () {
        return false;
    });
    // 语言选择
    $('body').on('click','.select dt', function () {
        $('.top-search').stop().slideUp('fast');
        $('.select dd').stop().slideToggle();
        return false;
    });
    $('body').on('click', function () {
        $('.top-search').stop().slideUp('fast');
        $('.select dd').stop().slideUp('fast');
    });

    if (_winw > 1200) {
      

    } else {
        $('body').on('click','.nav .v1', function () {
           
            if ($(this).siblings('.sub').length) {
                $(this).siblings('.sub').stop().slideToggle().parents('li').toggleClass('on').siblings('li').removeClass('on').find('.sub').stop().slideUp();
            }else{
                $('.nav').stop().slideUp('fast');
                $('.menuBtn').removeClass('open');
            }
            
        });
        $('body').on('click','.sub .v2', function () {
            $('.nav').stop().slideUp('fast');
            $('.menuBtn').removeClass('open');
        });
    }

    
    /*
    // 头部动态加类
    var header = $('.header'),
        headerH = header.height(),
        initScrh = $('body').scrollTop();
        function changeHeader(scrH) {
            if (scrH > headerH) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    }
    changeHeader(initScrh);
    $('body').on('scroll', function () {
        var _scrH = $('body').scrollTop();
        changeHeader(_scrH);
    });
    */

    $(document).on('click', '.ul-jobsb1 .open', function (e) {
        var $this = $(this)
        $this.parents('li').toggleClass('on');
    });
    

    $(document).on('click','.m-adv .moretxt', function () {
        var $that = $(this);
        $that.parents('.txt').find('.desc').toggleClass('len1');
    });
});



